import { render, staticRenderFns } from "./HiqHeader.vue?vue&type=template&id=4dcc8b54&scoped=true&"
import script from "./HiqHeader.vue?vue&type=script&lang=js&"
export * from "./HiqHeader.vue?vue&type=script&lang=js&"
import style0 from "./HiqHeader.vue?vue&type=style&index=0&id=4dcc8b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc8b54",
  null
  
)

export default component.exports